import { LoginTheme } from "./LoginTheme";
import { LayoutTheme } from "./LayoutTheme";

const Themes = {
  Login: LoginTheme,
  Layout: LayoutTheme,
};

export default Themes;
